module.exports = __webpack_public_path__ + "img/icon-404.762beb56.svg";